import { TreePlantedDiv } from "../NftDetails/style";
import {
  AboutBottomMidSection
} from "./style";
import { Button } from "../../components/Buttons";

const AboutBottomSection = () => {

  return (
    <>
      <AboutBottomMidSection>
        <ul>
          <li>
            <h2>Empowering Communities through Digital Asset Ownership</h2>
            <p>
            VYGA harnesses the power of Digital Assets to bring people together, creating a sense of ownership and unity. Our platform enables users to engage in meaningful ways, using digital assets to build lasting connections. Experience the future of community interaction through shared, Digital Asset-driven ownership.
            </p>
            <div>
              <Button variant="secondary">Learn More</Button>
              <Button variant="outlinedTheme">Get in touch</Button>
            </div>
          </li>
          <li>
            <TreePlantedDiv>
              <p>Community Members Engaged:</p>
              <span>
                <h4>15,000+</h4>
              </span>
            </TreePlantedDiv>
            <TreePlantedDiv>
              <p>Projects Funded through NFTs:</p>
              <span>
                <h4>200+</h4>
              </span>
            </TreePlantedDiv>
            <TreePlantedDiv>
              <p>Contributions to Sustainability:</p>
              <span>
                <h4>$500,000+</h4>
              </span>
            </TreePlantedDiv>
            <TreePlantedDiv>
              <p>Global Reach:</p>
              <span>
                <h4>50+ Countries</h4>
              </span>
            </TreePlantedDiv>
          </li>
        </ul>
      </AboutBottomMidSection>
    </>
  );
};

export default AboutBottomSection;
